/*
  UE variant gallery (replaces the VIM app).
  snippets/product.liquid renders only the selected variant's media group. On variant change the
  theme already fetches the re-rendered section (passed here as `html`), so we swap in that
  section's gallery and rebuild the theme's own Flickity slider. No extra network request.
*/
(function () {
  if (window.ueVariantGalleryLoaded) return;
  window.ueVariantGalleryLoaded = true;

  function revealImages(root) {
    root.querySelectorAll('[data-aos]').forEach((el) => el.classList.add('aos-animate', 'no-animation'));
    if (root.hasAttribute('data-aos')) root.classList.add('aos-animate', 'no-animation');
    root.querySelectorAll('img.is-loading').forEach((img) => {
      const done = () => {
        img.classList.remove('is-loading');
        img.parentNode && img.parentNode.classList.remove('is-loading');
      };
      img.complete ? done() : img.addEventListener('load', done, { once: true });
    });
  }

  function swapGallery({ sectionId, html, variant }) {
    if (!html || !variant) return;

    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (productInfo.sectionId !== sectionId) return;

      const galleryId = `ProductPhoto--${sectionId}-${productInfo.dataset.productId}`;
      const current = productInfo.querySelector(`[id="${galleryId}"]`);
      const next = html.querySelector(`[id="${galleryId}"]`);
      if (!current || !next) return;

      // Same group (or ungrouped product): the theme's own updateMedia() already handled it.
      const nextGroup = next.getAttribute('data-ue-gallery-group');
      if (nextGroup === 'all' || nextGroup === current.getAttribute('data-ue-gallery-group')) return;

      productInfo.flkty?.destroy();
      productInfo.flktyNav?.destroy();
      productInfo.flkty = null;
      productInfo.flktyNav = null;

      const fresh = document.importNode(next, true);
      revealImages(fresh);
      current.replaceWith(fresh); // <zoom-images> re-binds itself in connectedCallback

      productInfo.checkSlider();
      productInfo.initMediaSwitch();
    });
  }

  function init() {
    if (typeof window.subscribe !== 'function' || !window.theme?.PUB_SUB_EVENTS?.variantChange) return;
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => swapGallery(data || {}));
  }

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
